import { useLocation, Navigate, Outlet } from "react-router-dom";
import { mainSelectors } from "stores/mainSlice";
import { connect } from "react-redux";
import { PONERA_ROUTES } from "routes";

export function RequireAuthInner(props) {
  const { allowedRoles, allowedModules = "" } = props;
  const user = props.userSelector;
  const location = useLocation();

  const hasModule =
    user?.modules?.find((module) => allowedModules?.includes(module)) ||
    allowedModules === "";

  return user?.roles?.find((role) => allowedRoles?.includes(role)) &&
    hasModule ? (
    <Outlet />
  ) : user?.profile?.id ? (
    <Navigate
      to={PONERA_ROUTES.UNAUTHORIZED}
      state={{ from: location }}
      replace
    />
  ) : (
    <Navigate to={PONERA_ROUTES.LOGIN} state={{ from: location }} replace />
  );
}

const mapStateToProps = (state) => {
  return {
    userSelector: mainSelectors.userSelector(state),
  };
};

const mapDispatchToProps = {};

const RequireAuth = connect(
  mapStateToProps,
  mapDispatchToProps
)(RequireAuthInner);

export default RequireAuth;
